// @flow

import DOM from '../../util/dom';
import {extend} from '../../util/util';
import Popup from '../popup';
import {ClickControlBase} from './click_control_base';
import {MapMouseEvent, MapTouchEvent} from '../events';
import type {Options} from './click_control_base';

/**
 * The `TrafficIncidentClickControl` adds the ability to show a popup when a Traffic Incident Icon  is clicked on.
 *
 * @implements {IControl}
 *
 * @example
 * const trafficIncidentClickControl = TrimbleMaps.TrafficIncidentClickControl();
 * map.addControl(trafficIncidentClickControl);
 */
class TrafficIncidentClickControl extends ClickControlBase {
    _incidentType: string;
    constructor(options: Options) {
        const opt = extend({layerId: 'trafficincidents-traffic_incidents'}, options);
        super(opt);
    }

    _onClick(event: MapMouseEvent | MapTouchEvent) {
        this._incidentType = '';
        // $FlowFixMe
        const features = event.features;
        if (features && features.length > 0) {
            const popupContentContainer = DOM.create('div', 'trimblemaps-ctrl-tipopup');
            if (features[0].properties && features[0].properties.incidentDesc) {
                const popupText = features[0].properties.incidentDesc.split(',').join('<br/>');
                popupContentContainer.innerHTML = popupText;
                this._popup = new Popup({})
                    .setLngLat(features[0].geometry.coordinates)
                    .setDOMContent(popupContentContainer);
                if (this._options.showPopup) {
                    this._popup.addTo(this._map);
                }
                this._incidentType = features[0].properties.incidentType;
            }
            this._clickControlEventHandler();
            event.preventDefault();
        }
    }

    _onContentFilter(e: Object) {
        if (e.id === 'trafficincidents') {
            if (e.data[0].value !== 'All' && e.data[0].value !== this._incidentType) {
                if (this._popup && this._popup.isOpen()) this._popup.remove();
            }
        }
    }
}

export default TrafficIncidentClickControl;
